import styled from 'styled-components';
import { Pane, PaneContent } from "./PageStructure.component";
import pliableLogo from '@assets/images/pliable/logo_with_text_black.png'
import { Link } from 'react-router-dom';


const Styles  = styled.div`
    h1 {
        font-size: 2rem;
        margin-bottom: 1.5rem;
    }

    .oops {
        color: var(--brand-gray-3);
        font-size: 10rem;
        font-weight: 100;
    }
`


const Page404 = () => {


    return <Styles><div className="d-flex">
        <div style={{width: '50%', height: '100vh'}} className=" border-right bg-white">
            <Pane>
                <PaneContent>
                    <div className="p-5">
                        <img src={pliableLogo} style={{width: '200px'}} className="mb-5"/>
                        <div className="oops">Oops!</div>
                        <h1>404: Page not found</h1>
                        <p>We can not find the page you are looking for.</p>
                        <hr />
                        <Link to="/" className="btn btn-primary">
                            <i className="mdi mdi-home"></i> Go to Home
                        </Link>
                    </div>
                </PaneContent>
            </Pane>
        </div>
    </div></Styles>
}

export default Page404;